import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import AdminPage from "../../components/AdminPage";
import TableComponent from "../../components/adminTableComponent";
import DeleteModalContent from "../../components/DeleteModalContent/DeleteModalContent";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { SpecificView } from "../../components/SpecificView/SpecificView";
import { AddFaqCategory } from "./addModal";
import { loadFAQCategories } from "./loadData";
import { FAQHeaders } from "./tableHeaders";

const FAQCategory = ({}) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [FAQCategories, setFAQCategories] = useState([]);
  const [opened, setOpened] = useState(false);
  const [update, setUpdate] = useState(false);
  const [viewModalState, setViewModalState] = useState(false);
  const [viewModalData, setViewModalData] = useState(null);
  const [editData, setEditData] = useState({});
  const [deleteData, setDeleteData] = useState({});
  const [deleteModalState, setDeleteModalState] = useState(false);
  const [editModalState, setEditModalState] = useState(false);

  useEffect(() => {
    loadFAQCategories(setLoading).then(setFAQCategories);
  }, [location.pathname, update]);

  return (
    <AdminPage title="FAQ Categories">
      <ModalWrapper
        opened={viewModalState}
        setOpened={setViewModalState}
        title={"FAQ Category Details"}
        InternalComponent={
          <SpecificView
            name={viewModalData?.faqCatName}
            description={viewModalData?.faqCatNote}
            date={viewModalData?.createdDate}
            status={viewModalData?.state}
          />
        }
      />
      <ModalWrapper
        opened={deleteModalState}
        setOpened={setDeleteModalState}
        title={"Delete FAQ Category"}
        InternalComponent={
          <DeleteModalContent
            route={`faqCategory/deleteFaqCategory/${deleteData?._id}`}
            type={"FAQ Category"}
            setUpdate={setUpdate}
            setOpened={setDeleteModalState}
            setLoading={setLoading}
          />
        }
      />
      <AddFaqCategory
        setOpened={setOpened}
        opened={opened}
        setUpdate={setUpdate}
        editData={editData}
        setEditData={setEditData}
        setEditModalState={setEditModalState}
        editModalState={editModalState}
        setLoading={setLoading}
      />
      <LoaderWrapper loading={loading}>
        <TableComponent
          headCells={FAQHeaders}
          rowData={FAQCategories}
          showAddButton={true}
          setOpened={setOpened}
          setViewModalState={setViewModalState}
          setViewModalData={setViewModalData}
          setEditData={setEditData}
          setEditModalState={setEditModalState}
          setDeleteData={setDeleteData}
          setDeleteModalState={setDeleteModalState}
        />
      </LoaderWrapper>
    </AdminPage>
  );
};

export default withTranslation()(FAQCategory);
